<template>
  <div class="MyOrder">
        <div class="main">
            <div>
              <el-tabs v-model="activeName" @tab-click="activeNameClick">
                <el-tab-pane :label="'全部('+countData.allorder+')'" name="all"></el-tab-pane>
                <el-tab-pane :label="'待支付('+countData.unpaid+')'" name="wait"></el-tab-pane>
                <el-tab-pane :label="'已完成('+countData.complete+')'" name="complete"></el-tab-pane>
                <el-tab-pane :label="'已取消('+countData.canceled+')'" name="cancel"></el-tab-pane>
              </el-tabs>
              <el-select v-model="myOrderApi.kmctype" @change="clickSelect">
                <el-option v-for="(item,index) in selectMenuList" :key="index" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </div>

            <template v-if="myOrderLists && myOrderLists.length == 0 && activeName == 'all' ">
              <div class="null">
                <img src="../../../../common/images/search/search-null.png" alt="">
                <p>当前暂无订单</p>
              </div>
            </template>
            <template v-else>
              <el-table :data="myOrderLists" style="width: 100%">
                <el-table-column label="订单信息" width="450px">
                  <template slot-scope="scope">
                    <div class="order-info">
                      <span>订单号：{{scope.row.orderno}}</span>
                      <span>订单时间：{{scope.row.datetime}}</span>
                    </div>
                    <div class="courses-card" @click="gotoRouterDetaills(scope.row.kmctype, scope.row.courseid)">
                      <div class="img"><img v-lazy="scope.row.coverurl" :alt="scope.row.subject"></div>
                      <div class="msg">
                        <p class="text-overflow">{{scope.row.subject}}</p>
                        <p class="money" v-if="scope.row.feetype == 1">免费</p>
                        <p class="money" v-else>{{scope.row.finalpaymoney}}</p>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="分类" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.kmctype == 2">报告</p>
                    <p v-if="scope.row.kmctype == 7">课程</p>
                    <p v-if="scope.row.kmctype == 8">题库</p>
                    <p v-if="scope.row.kmctype == 13">活动</p>
                  </template>
                </el-table-column>
                <el-table-column label="订单状态" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.status == 30" class="color-1">已完成</p>
                    <p v-else-if="scope.row.status == 9" class="color-2">待支付</p>
                    <p v-else-if="scope.row.status == 100" class="color-3">已取消</p>
                    <template v-if="scope.row.kmctype == 13">
                        <p v-if="scope.row.status == 1" class="color-2">待审核</p>
                       <p v-else-if="scope.row.status == 3" class="color-4">审核失败</p>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="right" width="250">
                  <template slot-scope="scope">
                    <div class="position">
                      
                      <template v-if="scope.row.status == 30">
                        <template v-if="scope.row.kmctype == 7">
                          <template v-if="scope.row.iscomment == 0">
                            <span class="active" @click='startpopu(scope.row)'>评价课程</span>
                            <span class="padding">|</span>
                          </template>
                          <span class="active" @click="gotoRouterDetaills(scope.row.kmctype, scope.row.courseid)">开始学习</span>
                          <span class="padding">|</span>
                          
                          <template>
                            <span class="active" @click="participateInJointable(scope.row)" v-if="scope.row.isjointable == 0">加入课表</span>
                            <span class="active" @click="participateInJointable(scope.row)" v-else>移出课表</span>
                          </template>

                        </template>
                        <template v-else-if="scope.row.kmctype == 8">
                          <span class="active" @click="gotoRouterDetaills(scope.row.kmctype, scope.row.courseid)">进入考试</span>
                        </template>
                        <template v-else-if="scope.row.kmctype == 2">
                          <span class="active" @click="gotoRouterDetaills(scope.row.kmctype, scope.row.courseid)">查看报告</span>
                          <span class="padding">|</span>
                          <span class="active"  @click="qRCode(scope.row.courseid)">手机打开</span>

                          <template v-if="scope.row.isdownload == 1">
                            <span class="padding">|</span>
                            <span class="active" @click="gotoRouterDetaills(scope.row.kmctype, scope.row.courseid)">去下载</span>
                          </template>
                        </template>
                        <template v-else-if="scope.row.kmctype == 13">
                          <span class="active" @click="openTicketDet(scope.row)">票券详情</span>
                        </template>

                      </template>
                      <!-- 已完成状态 -->

                      <template v-else-if="scope.row.status == 9">
                        <span class="active" @click="openTicketDet(scope.row)" v-if="scope.row.kmctype == 13">票券详情</span>
                        <span class="padding">|</span>
                        <span class="active" @click="cancelMyOrder(scope.row.orderno,scope.row.kmctype)">取消订单</span>
                        <span class="padding">|</span>
                        <span class="active" @click="gotoRouterPay(scope.row.orderno, scope.row.courseid,scope.row.kmctype)">去支付</span>
                      </template>
                      <!-- 待支付状态 -->

                      <template v-else-if="scope.row.status == 100||(scope.row.status == 3&&scope.row.kmctype == 13)">
                        <template v-if="scope.row.kmctype == 13">
                           <span class="active" @click="openTicketDet(scope.row)">票券详情</span>
                          <span class="padding">|</span>
                          <span class="active" @click="goActiDet(scope.row.courseid)">重新报名</span>
                        </template>
                        <template v-else>
                          <span class="active" @click="gotoRouterShop(scope.row.courseid, scope.row.kmctype)">重新购买</span>
                        </template>
                      </template>
                      <!-- 已取消状态 -->
                      <template  v-else-if="scope.row.status == 1&&scope.row.kmctype == 13">
                        <span class="active" @click="openTicketDet(scope.row)">票券详情</span>
                        <span class="padding">|</span>
                        <span class="active" @click="cancelMyOrder(scope.row.orderno,scope.row.kmctype)">取消订单</span>
                      </template>
                      <!--待审核状态 只有活动才有 08-13-->
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination background layout="prev, pager, next" :current-page.sync='myOrderApi.page'  @current-change="handleCurrentChange" :total="rowCount"> </el-pagination>
            </template>
        </div>
        <Evaluate ref="evaluate" @evaluateSuccess='evaluateSuccess'></Evaluate>
        <TicketDet ref="ticketDet"></TicketDet>
        <el-dialog :visible.sync="dialogQrcode" :before-close="handleQrcode" width="250px">
          <img style="margin:auto;margin-top: 0" :src="qrcodeimg" alt="二维码">
          <p align="center">手机扫一扫</p>
        </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {urlToQRCode} from 'common/js/tools'
import merge from 'webpack-merge'
import {getAllOrders, cancelMyOrderInfo, operateJoinCourse,cancelEventOrderByEnroll} from 'api/personalCenterApi'
import {getPayResultInfo,getOrderPayUrl} from 'api/api'
import Evaluate from './../components/Evaluate'
import TicketDet from './../components/ticketDet'

export default {
  name: 'MyOrder',
  data () {
    return {
      activeName: 'all', // 选项列表名称
      myOrderLists: [], // 课程列表
      myOrderApi: {status: '', page: 1, kmctype: '', pageSize: 10},  // 接口api
      rowCount: 0,  // 数据条数
      countData: {canceled: 0, allorder: 0, unpaid: 0, complete: 0}, // 数据
      selectMenuList: [{name:'全部', code:''},{name:'课程', code:'7'},{name:'题库', code:'8'},{name:'报告', code:'2'},{name:'活动', code:'13'}], // 分类列表
      activeAllCourseLists: {}, // 选中的课程列表
      dialogQrcode: false,
      qrcodeimg: ''
    }
  },
  mounted () {
    // 判断是否有类型
    if (this.$route.query.kmctype) {
      this.myOrderApi.kmctype = this.$route.query.kmctype.toString()
    }
    // 订单列表接口
    this.getAllOrdersList('', 1)
  },  
  methods: {
    getAllOrdersList(status, page) {  // 订单列表

      this.myOrderApi.status = status
      this.myOrderApi.page = page

      this.setLoading(true)

      getAllOrders({
        data: this.myOrderApi,
        success: data => {
          this.setLoading(false)
          this.myOrderLists = data.data.content
          this.rowCount = data.data.pageinfo.rowCount
          this.countData = data.data.countlist[0]
          // console.log('myOrderLists', this.myOrderLists)
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }

      })
    },
    clickSelect() { // 选中分类发生变化

      // 修改路由
      this.$router.push({query: merge(this.$route.query, {'kmctype': this.myOrderApi.kmctype})})
      
      // this.getAllOrdersList(this.myOrderApi.status, 1)
    },
    activeNameClick(activeName) { // 列表切换
      switch(activeName.name) {
        case 'all':
            this.myOrderApi.status = ''
          break;
        case 'wait':
            this.myOrderApi.status = 9
          break;
        case 'complete':
            this.myOrderApi.status = 30
          break;
        case 'cancel':
            this.myOrderApi.status = 100
          break;
      }
      // 切换列表的同时 页数重置
      this.getAllOrdersList(this.myOrderApi.status, 1)
    },
    handleCurrentChange(val) { // 数据翻页
      this.getAllOrdersList(this.myOrderApi.status, val)
    },
    cancelMyOrder(orderno,type) { // 取消订单接口
      this.$confirm('此操作将取消该订单，是否继续？','提示', {
        confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          this.setLoading(true)
          if(type==13){ //活动取消订单
              cancelEventOrderByEnroll({ // 调用取消接口
                  data: {orderno: orderno},
                  success: data => {
                      this.setLoading(false);
                      if (data.code == '000') {
                          this.$message.success('取消订单成功!');
                          this.getAllOrdersList(this.myOrderApi.status, 1)
                      } else {
                          this.$message.error(data.msg)
                      }
                  },
                  error: data => {
                      this.setLoading(false)
                      this.$message.error(data.msg)
                  }
              })
          }else{
              cancelMyOrderInfo({ // 调用取消接口
                  data: {orderno: orderno},
                  success: data => {
                      this.setLoading(false)
                      if (data.code == '000') {
                          this.$message.success('取消订单成功!')
                          this.getAllOrdersList(this.myOrderApi.status, 1)
                      } else {
                          this.$message.error(data.msg)
                      }
                  },
                  error: data => {
                      this.setLoading(false)
                      this.$message.error(data.msg)
                  }
              })
          }
        }).catch(() => {})
    },
    gotoRouterDetaills(kmctype, cid) {  // 前往详情页面
      if (kmctype == 8) {
              const { href } = this.$router.resolve({
                name: "QuestionDetails",
                query: {
                    qid: cid
                }
              })
              window.open(href, '_blank');
      } else if (kmctype == 7) {
              const { href } = this.$router.resolve({
                name: "CourseDetails",
                query: {
                    cid: cid
                }
              })
              window.open(href, '_blank');
      } else if (kmctype == 2) {
          const { href } = this.$router.resolve({
                name: "ReportDetails",
                query: {
                    reportid: cid
                }
              })
              window.open(href, '_blank');
      }else if (kmctype == 13) {
          const { href } = this.$router.resolve({
              name: "HdDetails",
              query: {
                  eventid: cid
              }
          })
          window.open(href, '_blank');
      }
    }, 
    gotoRouterPay(orderno, cid,kmctype) {  // 前往支付页面
        this.setLoading(true)
        let params = {  // 接口参数
                orderno: orderno, // 订单号
                resulturl: `http://localhost:6001/p/orderbr?cid=${cid}` // 支付结果页面id
            }
            if(kmctype==13){ //活动支付
                getOrderPayUrl({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        window.open(data.data, '_blank')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }else{
                getPayResultInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        window.open(data.data.url, '_blank')
                        // console.log(data.data)
                        // window.location.replace(data.data.url)
                    },
                    error: data => {
                        // console.log('error：', data)
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
    },
     // 分享二维码生成
    qRCode(reportid) {
        this.dialogQrcode = true

        this.qrcodeimg = urlToQRCode(window.location.origin+'/m/MReportDetails?reportid='+reportid)  // 二维码内容
      
    },
    handleQrcode() {
      this.dialogQrcode = false
    },
    gotoRouterShop(cid, kmctype) {  // 前往购买页面
        let querylist = {}
        querylist = {'kmcinnerid': cid, 'kmctype': kmctype} 
        // if (kmctype == 2) {
        //     querylist = {'reportid': cid, 'kmctype': kmctype} 
        // } else if (kmctype == 7)  {
        //     querylist = {'cid': cid, 'kmctype': kmctype}
        // } else if (kmctype == 8) {
        //     querylist = {'qid': cid, 'kmctype': kmctype}
        // }

        const {href} = this.$router.resolve({
          name: 'OrderIndex', query: querylist
        })

        window.open(href,'_blank')
    },
    startpopu(list) { // 评价课程
      // console.log(list)
      this.activeAllCourseLists = list
      this.$refs.evaluate.startPopu(list.courseid)
    },
    evaluateSuccess() { // 课程评价成功
      this.activeAllCourseLists.iscomment = 1
      // this.getUserAllCourseLists(1)
    },
    participateInJointable(item) {  // 加入/移出课表
        this.activeAllCourseLists = item  // 取得列表
        
        let courseid = item.courseid, 
            status = item.isjointable

        if (status == 1) {
            this.$confirm('是否需要将课程移出课表?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                  this.jointableApi(courseid, 2)

              }).catch(() => {})
        } else {
            this.jointableApi(courseid, 1)
        } 

    },
    jointableApi(courseid, status) {  // 加入/移出课表接口调用 1 加入 2 移除
      this.setLoading(true)
      operateJoinCourse({
        data: {courseid: courseid, optype: status},
        success: data => {

          this.setLoading(false)
          if (data.code == '000') {

            this.$message.success('操作成功')

            if (status == 2) {  // 移除课表成功
              this.activeAllCourseLists.isjointable = 0
            } else {  // 加入课表成功
              this.activeAllCourseLists.isjointable = 1
            }
            // this.getUserAllCourseLists(1)
            // this.activeAllCourseLists.isjointable = ''

            // 刷新基本信息统计
            this.$parent.info()

          } else {
            this.$message.error(data.msg)
          }
            
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
      // console.log(courseid, status)
    },
      //票券详情
      openTicketDet(row){
        this.$refs.ticketDet.open(row.courseid,row.orderno,0)
      },
      //重新报名
      goActiDet(id){
          this.$router.push({name: 'HdDetails',query:{eventid:id}})
      },
    ...mapActions(['setLoading'])
  },
  filters: {},
    watch: {
      $route: {
        handler() {
          // 路由是否发生变化
          if (this.$route.query.kmctype) {
              this.myOrderApi.kmctype = this.$route.query.kmctype.toString()
          }
          // 订单列表接口
          this.getAllOrdersList('', 1)
          this.activeName = 'all'
        }
    }
  },
  computed: {},
  components: {
    Evaluate,TicketDet
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.MyOrder {
    .el-dialog__body {
      padding-top: 12px;
    }
    .main {
      position: relative;
    }
    .el-select {
      position: absolute;
      width: 128px;
      right: 30px;
      top: 8px;
    }
    .el-table {
      thead {
        th {
          background: #E5E5E5;
        }
      }
      tr {
        td {
          padding-top: 62px;
        }
      }
      .order-info {
        position: absolute;
        z-index: 2;
        left: 0;
        top: 0;
        width: 902px;
        height: 48px;
        line-height: 40px;
        background: #F8F8F8;
        border-top: solid 8px #fff;

        span {
          margin-left: 20px;
          margin-right: 12px;
          font-size: 14px;
          color: #333;
        }
      }
      .color-1 {
        color: #0ABF53;
      }
      .color-2 {
        color: #FFA904;
      }
      .color-4{
        color: #F56C6C;
      }
      .color- {
        color: #999999;
      }

    }
}
</style>